import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
@Component({
  selector: 'app-visits',
  templateUrl: './visits.component.html',
  styleUrls: ['./visits.component.scss']
})
export class VisitsComponent implements OnInit {
  @Input() medFileId;
  PARAM_KEY = [CommonConstants.STATUS];
  PARAM__CODE_KEY=[CommonConstants.SERVICE_CATEGORY];
  SERVICE_KEYS = [CommonConstants.MED_VISITS, CommonConstants.MED_NEEDS];
  masterValues: any;
  sCategory: any;
  status: any;
  medNeeds=[];
  visits=[];
  medNeedsForm: FormGroup;
  medVisitForm: FormGroup;
  submitted: boolean;
  masterCodes=[];
  constructor(private modal: NgbModal,private fb: FormBuilder, private medicalFileService: MedicalFileService, private masterService: MasterService
    , private toastrService: ToastrService, private sharedService: SharedService, private modalService: BsModalService, private loaderService: LoaderService) {
      this.getVisitGroup();
      this.getMedNeedGroup();
     }

  ngOnInit() {
    this.loadMaster();
    this.loadMedVisitNeeds();
  }
  visitAddModal(visit) {
    this.medVisitForm.reset();
    this.modal.open(visit, { size: 'lg', container: '.page-content' });
  }
  taskAddModal(task) {
    this.medNeedsForm.reset();
    this.modal.open(task, { size: 'lg', container: '.page-content' });
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });
    this.masterService.getMastersCodesByParamKey(this.PARAM__CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterCodes = response['result'];
        this.sCategory = this.masterCodes.filter(master => master.paramKey === CommonConstants.SERVICE_CATEGORY && master.parentId===0);
      }
    });
  }
  loadMedVisitNeeds(){
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if(response["code"]=="S0000" && response["result"]){
        let visitneeds=response["result"];
        this.visits=visitneeds[CommonConstants.MED_VISITS];
        this.medNeeds=visitneeds[CommonConstants.MED_NEEDS];
      }
    },
    error => {
      swal.fire("Error", "Error Occured While Fetching Visit Details", 'error');
    })
  }

  getVisitGroup(){
    this.medVisitForm = this.fb.group({
    'medviId':[],
    'medfiId':[],
    'medviComment':new FormControl(),
    'medviDatetime':new FormControl(),
    'medviDuration':new FormControl(),
    'medviReqDate':new FormControl(),
    'patieId':new FormControl(),
    'medviVisitor':new FormControl(),
    'medviplace':new FormControl(),
    'medviAlert':[false],
    'staRecCode':[],
    'statuCode':new FormControl()
  })
  }
  getMedNeedGroup(){
    this.medNeedsForm= this.fb.group({
    'medneId':[],
    'medfiId':[],
    'medneConcernedPerson':new FormControl(),
    'medneDoneDate':new FormControl(),
    'medneNeed':new FormControl(),
    'medneReqDate':new FormControl(),
    'patieId':new FormControl(),
    'srvcaId':new FormControl(),
    'medneReqWay':new FormControl(),
    'staRecCode':[],
    'statuCode':new FormControl()
  })
  }
	
  saveMedVisits() {
    this.submitted = true;
    if (this.medVisitForm.invalid) {
      return;
    }
    let jsonData = this.medVisitForm.value;
    jsonData["medviReqDate"]=this.visitControls.medviReqDate.value ? this.sharedService.getDateFormat(this.visitControls.medviReqDate.value) : null;
    jsonData["medviDatetime"]=this.visitControls.medviDatetime.value ? this.sharedService.getDateFormat(this.visitControls.medviDatetime.value) : null;
    jsonData["medfiId"]=this.medFileId;
    this.loaderService.display(true);
    this.medicalFileService.saveMedVisits(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        if(this.visits && this.visits.length > 0){
          this.visits=this.visits.filter(visit => visit.medviId !== response.medviId);
        }
        this.visits.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Second Opinion", 'error');
    })
  }
  saveMedNeeds() {
    this.submitted = true;
    if (this.medNeedsForm.invalid) {
      return;
    }
    let jsonData = this.medNeedsForm.value;
    jsonData["medneDoneDate"]=this.medNeedControls.medneDoneDate.value ? this.sharedService.getDateFormat(this.medNeedControls.medneDoneDate.value) : null;
    jsonData["medneReqDate"]=this.medNeedControls.medneReqDate.value ? this.sharedService.getDateFormat(this.medNeedControls.medneReqDate.value) : null;
    jsonData["medfiId"]=this.medFileId;
    this.loaderService.display(true);
    this.medicalFileService.saveMedNeeds(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        if(this.medNeeds && this.medNeeds.length > 0){
          this.medNeeds=this.medNeeds.filter(need => need.medneId !== response.medneId);
        }
        this.medNeeds.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Second Opinion", 'error');
    })
  }
  reset(){
    this.medVisitForm.reset();
    this.medNeedsForm.reset();
  }
  get visitControls() { return this.medVisitForm.controls; }
  onVisitSelect(event, medvisit) {
    this.medVisitForm.reset();
    let visit = event.data;
    this.medVisitForm.patchValue({});
    Object.keys(visit).forEach(name => {
      if (visit[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name)) {
        this.visitControls[name].patchValue(visit[name]);
      }
    });
    this.modal.open(medvisit, { size: 'lg', container: '.page-content' });
  }
  get medNeedControls() { return this.medNeedsForm.controls; }
  onMedNeedSelect(event, medicalNeed) {
    this.medNeedsForm.reset();
    let medNeed = event.data;
    this.medNeedsForm.patchValue({});
    Object.keys(medNeed).forEach(name => {
      if (medNeed[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name)) {
        this.medNeedControls[name].patchValue(medNeed[name]);
      }
    });
    this.modal.open(medicalNeed, { size: 'lg', container: '.page-content' });
  }
}
